import { render, staticRenderFns } from "./ResultMessage.vue?vue&type=template&id=4f115fec&scoped=true&"
import script from "./ResultMessage.vue?vue&type=script&lang=js&"
export * from "./ResultMessage.vue?vue&type=script&lang=js&"
import style0 from "./ResultMessage.vue?vue&type=style&index=0&id=4f115fec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f115fec",
  null
  
)

component.options.__file = "ResultMessage.vue"
export default component.exports